import logoRote from "assets/images/logorote.png";
import bgSignIn from "assets/images/bg-sign-in-cover.jpeg";
import bgSignUp from "assets/images/bg-sign-up-cover.jpeg";
import { resolveUploadUrl } from "utils";

export const SITE_ASSET_KEYS = {
  LOGO_APLIKASI: "LOGO_APLIKASI",
  BG_HERO_LANDING: "BG_HERO_LANDING",
  BG_LOGIN: "BG_LOGIN",
  BG_REGISTER: "BG_REGISTER",
  BG_VERIFIKASI: "BG_VERIFIKASI",
};

export const SITE_ASSET_FALLBACKS = {
  [SITE_ASSET_KEYS.LOGO_APLIKASI]: logoRote,
  [SITE_ASSET_KEYS.BG_HERO_LANDING]: bgSignIn,
  [SITE_ASSET_KEYS.BG_LOGIN]: bgSignIn,
  [SITE_ASSET_KEYS.BG_REGISTER]: bgSignUp,
  [SITE_ASSET_KEYS.BG_VERIFIKASI]: bgSignIn,
};

export const getAssetUrlFromMap = (assetsMap, kode, fallback) => {
  const item = assetsMap?.[kode];
  if (item?.file_url) return resolveUploadUrl(item.file_url);
  return fallback || SITE_ASSET_FALLBACKS[kode] || "";
};
